import React from "react";
import styles from "./TemplateOnboardingGuide.module.css";

/**
 * Timeline informativa (não-bloqueante) exibida quando há um modelo aguardando
 * aprovação (PENDING) e nenhum modelo ativo ainda. Explica os próximos passos
 * em linguagem do dono de negócio — sem jargão técnico da Meta.
 */
const STEPS = [
  {
    icon: "✅",
    title: "Modelo enviado",
    desc: "Recebemos sua mensagem e mandamos para análise.",
  },
  {
    icon: "⏳",
    title: "Análise em andamento",
    desc: "A aprovação costuma sair em até 24 horas.",
  },
  {
    icon: "📬",
    title: "Verifique o status",
    desc: "Volte aqui e clique em “Verificar status” no modelo.",
  },
  {
    icon: "🟢",
    title: "Ative o modelo",
    desc: "Assim que aprovado, ative para começar a enviar lembretes.",
  },
];

export default function TemplateOnboardingGuide() {
  return (
    <aside className={styles.guide} aria-label="O que acontece agora">
      <p className={styles.heading}>
        Seu modelo foi enviado! O que acontece agora?
      </p>
      <ol className={styles.steps}>
        {STEPS.map((step, idx) => (
          <li key={step.title} className={styles.step}>
            <span className={styles.stepIcon} aria-hidden="true">
              {step.icon}
            </span>
            <div className={styles.stepBody}>
              <span className={styles.stepTitle}>
                {idx + 1}. {step.title}
              </span>
              <span className={styles.stepDesc}>{step.desc}</span>
            </div>
          </li>
        ))}
      </ol>
    </aside>
  );
}
